module.exports = __webpack_public_path__ + "static/img/modal-error.ead1d008.png";